export default "__VITE_ASSET__DtZ4r$JR__"